import { ExternalLink, RefreshCw } from "lucide-react";
import { Button } from "../../components/ui/Button";
import { Spinner } from "../../components/ui/misc";
import { usePdfBlob } from "./usePdfBlob";

/** The real WeasyPrint render, shown from a blob: URL (spec §4.4; the vhost forbids framing https: pages). */
export function PdfPanel({ title, load }: { title: string; load: () => Promise<Blob> }) {
  const { url, loading, error, refresh } = usePdfBlob(load);
  return (
    <div className="flex h-full min-h-0 flex-col gap-2">
      <div className="flex items-center gap-2">
        <Button size="sm" onClick={refresh} disabled={loading} aria-label="Refresh preview">
          <RefreshCw size={14} /> Refresh
        </Button>
        {url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener"
            className="inline-flex items-center gap-1 text-sm text-green-ink underline"
          >
            Open in a new tab <ExternalLink size={13} />
          </a>
        ) : null}
        {loading ? <Spinner label="Rendering…" /> : null}
      </div>
      {error ? (
        <p role="alert" className="rounded-md border border-danger/40 bg-danger-wash px-3 py-2 text-sm text-danger">
          {error}
        </p>
      ) : null}
      {url ? (
        <iframe
          title={`PDF preview of ${title}`}
          src={url}
          className="min-h-0 flex-1 rounded-md border border-line bg-white"
        />
      ) : null}
    </div>
  );
}
